/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Button, Col, Form, Modal, Row, Select, Space, Table, Tabs } from "antd"
import React, { useEffect, useRef, useState } from "react"
import styles from "../filing.module.css"
import { TabBar } from "../../../compnents/widgets/TabBar"
import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import {
  selectTenantCityCode,
  selectUserName,
} from "../../../app/applicationSlice"
import { EditableList } from "../../../compnents/list/EditableList"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import axios from "axios"
import { useQuery } from "../../../utils/HttpUtils"
import { useLocation } from "react-router-dom"
import { DoctorFormModal } from "./DoctorFormModal"
import moment from "moment"
import { DateTimeFormatSimplePrintCharge } from "../../../models/datetime"
import { AXIOS_IP, exportPdf } from "../fileUploadService"

export const TcmPastingDetail = () => {
  const { TabPane } = Tabs

  const [form] = Form.useForm()

  const query: any = useQuery()

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [updateDoctor, setUpdateDoctor] = useState<any>({})

  const [doctorVisible, setDoctorVisible] = useState(false)

  const [baseUrl, setBaseUrl] = useState("")

  const [baseType, setBaseType] = useState(true)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [detail, setDetail] = useState<any>({})

  const [token, setToken] = useState("")

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            location.state?.state == 1
              ? `${AXIOS_IP}/filingTcmPatch/detail`
              : `${AXIOS_IP}/filingReviewTcmPatchRecord/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: location.state?.id },
        }).then((res) => {
          const data = res.data.data
          const filterData = {
            ...data,
            managementSystemFileUrl: data?.managementSystemFileUrl || [],
            riskPreventionFileUrl: data?.riskPreventionFileUrl || [],
            medicalEthicsFileUrl: data?.medicalEthicsFileUrl || [],
            doctorInfoList: data?.doctorInfoList
              ? data?.doctorInfoList?.map((v: any) => {
                  return {
                    ...v,
                    professionalTitleCertificateFileUrl:
                      v?.professionalTitleCertificateFileUrl || [],
                    professionalQualificationCertificateFileUrl:
                      v?.professionalQualificationCertificateFileUrl || [],
                    practiceCertificateFileUrl:
                      v?.practiceCertificateFileUrl || [],
                    institutionReviewFileUrl: v?.institutionReviewFileUrl || [],
                  }
                })
              : [],
          }
          setDetail(filterData)
        })
      })
  }

  const getBase64Url = (v: any) => {
    axios({
      url: `${AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      setBaseType(v.fileType?.includes("pdf") ? true : false)
      setBaseUrl(`data:${v.fileType};base64,${res.data}`)
      setIsModalVisible(true)
    })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "中医冬病夏治穴位贴敷备案详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.type },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { id: location.state?.id },
                      token,
                      path: "/filingTcmPatch/generatePdf",
                      fileName: "中医冬病夏治穴位贴敷备案详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Form
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 19 }}
          colon={false}
        >
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
              paddingBottom: "30px",
            }}
          >
            中医冬病夏治穴位贴敷备案详情
          </Row>
          <Form.Item label="诊疗病种" name="diseasesTreated" rules={[{ required: true }]}>{detail?.diseasesTreated}</Form.Item>
          <Form.Item label="处方用药" name="prescriptionMedication" rules={[{ required: true }]}>
            {detail?.prescriptionMedication}
          </Form.Item>
          <Form.Item label="每次治疗剂量" name="dosagePerTreatment" rules={[{ required: true }]}>
            {detail?.dosagePerTreatment}
          </Form.Item>
          <Form.Item label="名称" name="drugName" rules={[{ required: true }]}>{detail?.drugName}</Form.Item>
          <Form.Item label="穴位" name="acuPoint" rules={[{ required: true }]}>{detail?.acuPoint}</Form.Item> 
          <Form.Item label="拟定处方的医师名单" name="doctorInfoList" rules={[{ required: true }]}>
            <Table
              dataSource={detail?.doctorInfoList || []}
              className={styles.QATable}
              columns={[
                {
                  title: "医生姓名",
                  align: "left",
                  width: "8rem",
                  ellipsis: true,
                  dataIndex: "name",
                },
                {
                  title: "人员类型",
                  align: "left",
                  width: "8rem",
                  ellipsis: true,
                  dataIndex: "personnelTypeName",
                },
                {
                  title: "操作",
                  align: "center",
                  width: "8rem",
                  ellipsis: true,
                  render: function Element(_, m) {
                    return (
                      <Space>
                        <Button
                          type="link"
                          onClick={() => {
                            setDoctorVisible(true)
                            setUpdateDoctor({
                              ...m,
                              fileZGUrl:
                                m.professionalQualificationCertificateFileUrl ||
                                [],
                              fileZCUrl:
                                m.professionalTitleCertificateFileUrl || [],
                              fileYSUrl: m.practiceCertificateFileUrl || [],
                              fileJGUrl: m.institutionReviewFileUrl || [],
                            })
                          }}
                        >
                          查看详情
                        </Button>
                      </Space>
                    )
                  },
                },
              ]}
              rowKey={(t: any) => t.id}
              pagination={false}
            />
          </Form.Item>
          <Form.Item label="禁忌症及相关注意事项" name="contraindicationsAndRelatedPrecautions" rules={[{ required: true }]}>
            {detail?.contraindicationsAndRelatedPrecautions}
          </Form.Item>
          <Form.Item label="备案号" name="filingNumber" rules={[{ required: true }]}>{detail?.filingNumber}</Form.Item>
          <Form.Item label="管理制度及技术操作规范" name="managementSystemFileUrl" rules={[{ required: true }]}>
            {detail?.managementSystemFileUrl?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", padding: "0 20px" }}
                    onClick={() => getBase64Url(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="风险防范及不良反应处置预案" name="riskPreventionFileUrl" rules={[{ required: true }]}>
            {detail?.riskPreventionFileUrl?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", padding: "0 20px" }}
                    onClick={() => getBase64Url(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Form.Item label="医学伦理审查意见表" name="medicalEthicsFileUrl" rules={[{ required: true }]}>
            {detail?.medicalEthicsFileUrl?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", padding: "0 20px" }}
                    onClick={() => getBase64Url(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
            }}
          >
            评估报告
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col offset={1} span={22}>
              <Table
                dataSource={detail?.evaluationReportList || []}
                columns={[
                  {
                    title: "序号",
                    key: "no",
                    align: "center",
                    width: "4rem",
                    render: (_1, _2, i) => `${i + 1}`,
                  },
                  {
                    title: "显效率",
                    width: "8rem",
                    align: "center",
                    ellipsis: true,
                    dataIndex: "apparentEfficiency",
                  },
                  {
                    title: "治愈率",
                    width: "8rem",
                    align: "center",
                    ellipsis: true,
                    dataIndex: "recoveryRate",
                  },
                  {
                    title: "不良反应",
                    align: "center",
                    ellipsis: true,
                    dataIndex: "adverseReactions",
                  },
                  {
                    title: "提交时间",
                    width: "10rem",
                    align: "center",
                    ellipsis: true,
                    dataIndex: "createTime",
                    render: (_, t) => {
                      return t.createTime
                        ? moment(t.createTime).format(
                            DateTimeFormatSimplePrintCharge
                          )
                        : "-"
                    },
                  },
                  {
                    title: "状态",
                    width: "8rem",
                    align: "center",
                    ellipsis: true,
                    dataIndex: "reviewStatusName",
                  },
                  {
                    title: "操作",
                    align: "center",
                    width: "8rem",
                    ellipsis: true,
                    render: function Element(_, m) {
                      return (
                        <Space>
                          <Button
                            type="link"
                            onClick={() =>
                              getBase64Url(
                                m.previousYearAssessmentReportFileUrl?.[0]
                              )
                            }
                          >
                            查看报告
                          </Button>
                        </Space>
                      )
                    },
                  },
                ]}
                rowKey={(t: any) => t.id}
                pagination={false}
              />
            </Col>
          </Row>
        </Form>
      </div>

      <DoctorFormModal
        visible={doctorVisible}
        updateDoctor={updateDoctor}
        editable={true}
        token={token}
        AXIOS_IP={AXIOS_IP}
        onOk={() => {
          setDoctorVisible(false)
        }}
        onCancel={() => setDoctorVisible(false)}
      />

      <Modal
        title={"预览"}
        visible={isModalVisible}
        footer={null}
        width={"80%"}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      >
        <div style={{ height: "650px" }}>
          {baseType ? (
            <iframe
              title="预览"
              style={{ width: "100%", height: "100%" }}
              src={baseUrl}
            />
          ) : (
            <img
              // v-else
              src={baseUrl}
              alt="预览图片"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </Modal>
    </>
  )
}
